import React, { FC } from "react";

import { images } from "assets/images";
import { useReports } from "hooks/useReports";

interface SearchOrDeleteElementProps {
  setHandleSearch: (value: boolean) => void;
}

const SearchOrDeleteElement: FC<SearchOrDeleteElementProps> = ({
  setHandleSearch,
}) => {
  const { searchKeyword, setSearchKeyword } = useReports();
  return searchKeyword ? (
    <button
      className="unsetDefaultButtonStyle"
      type="button"
      aria-label="Clear search"
      onClick={() => setSearchKeyword("")}
    >
      <images.Delete />
    </button>
  ) : (
    <button
      type="button"
      aria-label="Search"
      onClick={() => setHandleSearch(true)}
      className="unsetDefaultButtonStyle"
    >
      <images.Search />
    </button>
  );
};

export default SearchOrDeleteElement;
